<template>
  <b-row>
    <b-col md="6">
      <input-select-search
        ref="produtoId"
        v-model="filtro.produtoId"
        :label="$t('SUPRIMENTOS.SELECIONAR_PRODUTO')"
        :options="opcoes.produtos"
        @input="buscaSaldoTotalEstoque"
        required
      />
    </b-col>
    <b-col md="4">
      <input-select-search
        ref="depositoId"
        v-model="filtro.depositoId"
        :label="$t('SUPRIMENTOS.SELECIONAR_DEPOSITO')"
        :options="opcoes.depositos"
        @input="buscaSaldoTotalEstoque"
      />
    </b-col>
    <b-col md="2">
      <input-text
        ref="saldoTotalProduto"
        v-model="saldoTotalProduto"
        :label="$t('SUPRIMENTOS.SALDO_TOTAL_ESTOQUE')"
        disabled
      />
    </b-col>
    <b-col md="auto">
      <b-button variant="primary" class="w-100 mb-3" @click="filtrar">
        {{ $t('GERAL.FILTRAR') }}
      </b-button>
    </b-col>
    <b-col md="auto">
      <b-button variant="secondary" class="w-100 mb-3" @click="limparFiltro">
        {{ $t('GERAL.LIMPAR') }}
      </b-button>
    </b-col>
    <b-col md="auto">
      <b-button class="w-100 mb-3" variant="info" @click="saidaManual">
        {{ $t('SUPRIMENTOS.SAIDA_MANUAL_PRODUTO') }}
      </b-button>
    </b-col>
    <b-col md="auto">
      <b-button variant="info" class="w-100 mb-3" @click="transferencia">
        {{ $t('SUPRIMENTOS.TRANSFERENCIA_DEPOSITOS') }}
      </b-button>
    </b-col>
    <b-col md="auto">
      <b-button variant="info" class="w-100 mb-3" @click="ajusteInventario">
        {{ $t('SUPRIMENTOS_ESTOQUE.AJUSTE_INVENTARIO') }}
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
// Utils & Aux:
import helpers from '@/common/utils/helpers';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';
import { START_LOADING, STOP_LOADING } from '@/store/Store';

// Components:
import { InputSelectSearch, InputText } from '@/components/inputs';

// services
import DepositoService from '@/common/services/depositos/depositos.service';
import ProdutoService from '@/common/services/produtos/produtos.service';
import EstoqueService from '@/common/services/estoque/estoque.service';

export default {
  components: {
    InputSelectSearch,
    InputText,
  },
  data() {
    return {
      saldoTotalProduto: null,
      filtro: {
        depositoId: '',
        produtoId: '',
      },
      modais: {
        produto: false,
        deposito: false,
      },
      opcoes: {
        produtos: [],
        depositos: [],
      },
      limpar: false,
    };
  },
  mounted() {
    this.getDepositos();
    this.getProdutos();
  },

  watch: {
    filtro: {
      handler(value) {
        this.$emit('filtro', value);
        if (!this.filtro.produtoId) {
          this.saldoTotalProduto = null;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    buscaSaldoTotalEstoque() {
      this.saldoTotalProduto = null;
      if (!this.filtro.produtoId) return;

      this.$store.dispatch(START_LOADING);
      EstoqueService.buscaSaldoTotalProduto(this.filtro)
        .then(({ data }) => {
          this.saldoTotalProduto = data;
        })
        .catch((error) => {
          mensagem.showErrors(error);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getDepositos() {
      this.$store.dispatch(START_LOADING);
      DepositoService.obterTodos()
        .then(({ data }) => {
          this.opcoes.depositos = data.itens.map((item) => ({
            text: item.descricao,
            value: item.id,
          }));
        })
        .catch(({ error }) => {
          mensagem.erro(this.$t('GERAL.ERRO'), error.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getProdutos() {
      this.$store.dispatch(START_LOADING);
      const normalize = (str) =>
        str.toString()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")

      ProdutoService.obterTodos()
        .then(({ data }) => {
          this.opcoes.produtos = data.map((item) => ({
            text: `${item.codigo} - ${normalize(item.descricao)}`,
            value: item.id,
          }));
        })
        .catch((error) => {
          mensagem.erro(this.$t('GERAL.ERRO'), error.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    filtrar() {
      if (!this.validarFormulario()) return;
      this.$emit('filtrar', {
        produtoId: this.filtro.produtoId,
        depositoId: this.filtro.depositoId,
      });
    },
    limparFiltro() {
      this.limpar = true;

      this.saldoTotalProduto = null;
      this.$emit('limpar', (this.filtro = {}));
    },
    openModal(key, item) {
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },
    saidaManual() {
      this.$emit('saida-manual', 'saidaManual');
    },
    ajusteInventario() {
      this.$emit('ajuste-inventario', 'ajusteInventario');
    },
    transferencia() {
      this.$emit('transferencia', 'transferencia');
    },
  },
};
</script>
